module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('select', {
    class: 'o-select qa-' + _vm.field.name + '__input',
    attrs: {
      "disabled": _vm.field.readonly,
      "readonly": _vm.field.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.update($event.target.value)
      }
    }
  }, [(!_vm.field.hasNoEmptyOption) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.field.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value,
        "selected": item.value == _vm.value ? 'selected' : ''
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n        " + _vm._s(_vm.displayValue) + "\n      ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f334de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/fields/FieldEnum.vue
// module id = 552
// module chunks = 1